import { render, staticRenderFns } from "./iframeView.vue?vue&type=template&id=42167ba4&scoped=true&"
import script from "./iframeView.vue?vue&type=script&lang=js&"
export * from "./iframeView.vue?vue&type=script&lang=js&"
import style0 from "./iframeView.vue?vue&type=style&index=0&id=42167ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42167ba4",
  null
  
)

export default component.exports